export default "__VITE_ASSET__CK5Y1wC2__"